// extracted by mini-css-extract-plugin
export default {"shadowButtonSet":"NavMenu_shadowButtonSet__337tg"};